<template lang="pug">
  v-row.course-analytic

    template(v-if="!$loader.isLoading")
      v-col(cols=12 md=8 lg=8)
        v-subheader
          |  Выберите необходимый курс / тему / урок
        select-course-subject(
          v-model="subject"
          :get-courses-method="getCourses"
        )
      v-col(
        cols=12 md=4
      )
        v-slide-y-reverse-transition
          task-progress(
            v-if="subject"
            :subject="subject"
          ).sdo-card.px-5
</template>

<script>
import SelectCourseSubject from '../../components/SelectCourseSubject.vue';
import TaskProgress from '../../components/TasksBySubject.vue';

export default {
  components: {
    SelectCourseSubject,
    TaskProgress,
  },
  data() {
    return {
      subject: null,
    };
  },
  methods: {
    getCourses() {
      return this.$api.courses.index({
        'search[teacher]': this.$user.data.id,
        expand: 'course_units_count',
      });
    },
  },
};
</script>
